// if 'PE' appears in marquee string, wrap it in a <span> tag
$('.slider-marquee p:contains("PE")').html((index, html) => {
	return html.replace(/(PE)/g, "<span>$&</span>");
});
